import "./ApprovalSummary.css";

interface ApprovalSummaryProps {
  totalApprovals: number,
  pendingApprovals: number,
  newApprovals: number,
  existingApprovals: number
  config?: boolean
}

const ApprovalSummary = ({ 
  totalApprovals,
  pendingApprovals,
  newApprovals,
  existingApprovals,
  config = false
}: ApprovalSummaryProps) => {

return (
    <div className="ApprovalSummary">
      <div className="ApprovalSummary-1 ApprovalSummary-common">
        <span>Approval Summary</span>
      </div>
        <div className="ApprovalSummary-2 ApprovalSummary-common">
            <div className="totalApproval">
                <p>{totalApprovals}</p>
                <span className="totalApprovalQuantity">Total Approvals</span>
            </div>
        </div>

      {!config && <div className="ApprovalSummary-3 ApprovalSummary-common">
        <span>{pendingApprovals}</span>
        <span className="finalApprovalQuantity">Pending Approvals</span>
      </div>}

      {config && <div className="ApprovalSummary-3 ApprovalSummary-common">
        <span>{newApprovals}</span>
        <span className="finalApprovalQuantity">New Approval</span>
      </div>}

      {config && <div className="ApprovalSummary-3 ApprovalSummary-common">
        <span>{existingApprovals}</span>
        <span className="finalApprovalQuantity">Update Requests</span>
      </div>}
    </div>
  );
};

export default ApprovalSummary;
